export default "__VITE_ASSET__DkId48g4__"